import { render, staticRenderFns } from "./WorkplaceShutdowns.vue?vue&type=template&id=45e2068b"
import script from "./WorkplaceShutdowns.vue?vue&type=script&lang=ts"
export * from "./WorkplaceShutdowns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports